import { render, staticRenderFns } from "./SichernConnect.vue?vue&type=template&id=2dd186c8&scoped=true"
import script from "./SichernConnect.vue?vue&type=script&lang=js"
export * from "./SichernConnect.vue?vue&type=script&lang=js"
import style0 from "./SichernConnect.vue?vue&type=style&index=0&id=2dd186c8&prod&scoped=true&lang=scss"
import style1 from "./SichernConnect.vue?vue&type=style&index=1&id=2dd186c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd186c8",
  null
  
)

export default component.exports